/**
 * Vendors in this list will always have visible prices.
 */
export const EXCLUDED_VENDORS_FROM_HIDE_PRICES: readonly number[] = [] as const;
/**
 * Vendors in this list will always have visible prices.
 */
export const EXCLUDED_VENDORS_FROM_HIDE_PRICES: readonly number[] = [] as const;
